var map = {
	"./2-card-teenpatti.png": 721,
	"./2-card-teenpatti.webp": 826,
	"./32-card-casino.png": 722,
	"./32-card-casino.webp": 827,
	"./amar-akbar.png": 723,
	"./amar-akbar.webp": 828,
	"./andar-bahar.png": 724,
	"./andar-bahar.webp": 829,
	"./crazy-time.png": 725,
	"./crazy-time.webp": 830,
	"./deal-no-deal.png": 726,
	"./deal-no-deal.webp": 831,
	"./dragon-tiger.png": 727,
	"./dragon-tiger.webp": 832,
	"./hi-lo.png": 728,
	"./hi-lo.webp": 833,
	"./lightning-dice.png": 729,
	"./lightning-dice.webp": 834,
	"./money-wheel.png": 730,
	"./money-wheel.webp": 835,
	"./roulette.png": 731,
	"./roulette.webp": 836,
	"./teenpatti.png": 732,
	"./teenpatti.webp": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2028;